export const navItems = [
  { key: "addUser", name: "Add User" },
  { key: "editAccess", name: "Edit Access" },
  { key: "disableUser", name: "Disable User" },
];
